import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import WhatWeDo from './components/WhatWeDo';
import AgentsSection from './components/AgentsSection';
import ErpSection from './components/ErpSection';
import TechSection from './components/TechSection';
import ProductsSection from './components/ProductsSection';
import UseCases from './components/UseCases';
import Methodology from './components/Methodology';
import WhyAcoma from './components/WhyAcoma';
import CtaSection from './components/CtaSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-950">
      <Navbar />
      <main>
        <Hero />
        <WhatWeDo />
        <AgentsSection />
        <ErpSection />
        <TechSection />
        <ProductsSection />
        <UseCases />
        <Methodology />
        <WhyAcoma />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}